import { render } from "./Verify.vue?vue&type=template&id=0d974a74&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d974a74"

export default script